<template>
  <el-container>
    <MigrationGuide />
    <router-view :class="{ 'page-container': shouldAddContainerClass }" />
    <TabBar v-if="showTabbar" />
  </el-container>
</template>

<script setup>
import { onMounted, computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import TabBar from "@/components/TabBar";
import MigrationGuide from "@/components/MigrationGuide";
import { initWxConfig, setWxShare } from "@/api/wxShare";

// 1. 控制哪些路由显示 TabBar (白名单)
const route = useRoute();
const tabbarPages = ["/", "/active", "/shop", "/mine"];
const shouldAddContainerClass = ref(false);
const showTabbar = computed(() => tabbarPages.includes(route.path));

// 2. 页面挂载后初始化微信分享
onMounted(async () => {
  await initWxConfig();
  setWxShare(); // 默认的全局分享配置
});

// 监听路由变化，更新class状态
watch(
  () => route.path,
  (newPath) => {
    // 检查当前路由是否在目标列表中
    shouldAddContainerClass.value = tabbarPages.includes(newPath);
  },
  { immediate: true } // 初始加载时立即执行一次
);
</script>

<style>
.page-container {
  padding-bottom: calc(10vh + env(safe-area-inset-bottom, 0px));
}

.el-container {
  width: 100%;
  height: 100%;
}

.el-message {
  pointer-events: none;
}

.el-message-box {
  width: 90%;
}

.el-select-dropdown__item {
  font-size: 16px;
  height: 40px;
  line-height: 40px;
}

.el-header {
  height: auto;
}

.el-badge__content {
  background-color: #f56c6c;
}

.message-class {
  width: -moz-max-content;
  width: max-content;
}

.message-class .el-message__content {
  line-height: 1.2;
}

/* 统一放 dialog 样式 */
.allDialog .el-dialog {
  border-radius: 10px;
  overflow: hidden;
}
.allDialog .el-dialog__title {
  font-size: 16px;
}
.allDialog .el-dialog__header {
  padding: 10px 20px;
  margin-right: 0;
}
.allDialog .el-dialog__body {
  padding: 0 20px 20px;
  text-align: center;
}
.allDialog .el-dialog__footer {
  border-top: 1px solid #ccc;
  padding: 0;
}
.allDialog .el-button {
  border: 0;
  border-radius: 0;
  background-color: transparent;
  width: 100%;
  height: 100%;
  font-size: 16px;
  padding: 15px 20px;
}

/* auth 样式 */
.auth-box .el-checkbox__inner:hover {
  border-color: #ee5f5c;
}
.auth-box .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #ee5f5c;
  border-color: #ee5f5c;
}

.el-card__header {
  padding: 0;
  border: none;
  width: 100%;
}

.el-image {
  display: block;
  width: 100%;
}

.list-card-body {
  padding: 10px;
}

.allDialog .dialog-footer {
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
}

.allDialog .el-button:focus,
.allDialog .el-button:hover {
  color: #606266;
}

.allDialog .el-button:last-child {
  border-left: 1px solid #ccc;
  color: #ee5f5c;
}

/*allDialog end*/

/*auth start*/
.auth-box .el-checkbox__inner:hover {
  border-color: #ee5f5c;
}

.auth-box .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #ee5f5c;
  border-color: #ee5f5c;
}

/*auth end*/

/*userinfo start*/
.userinfo-bm-input .el-select {
  width: 100%;
}

.userinfo-bm-input .el-form-item {
  margin-bottom: 0;
}

.userinfo-bm-input .el-input__inner {
  border: 0;
  padding-left: 0;
  height: 45px;
  line-height: 45px;
}

.userinfo-bm-input .el-input__icon {
  line-height: 45px;
}

.userinfo-bm-input .el-select .el-input .el-select__caret {
  font-size: 16px;
}

.userinfo-bm-input .el-form-item__label,
.userinfo-bm-input .el-input {
  font-size: 16px;
  height: 45px;
  line-height: 45px;
}

.userinfo-bm-input .userinfo-code-wrap .el-input__inner {
  padding: 0 15px 0 0;
}

.userinfo-bm-input .userinfo-code-wrap .el-form-item__content {
  margin-left: 0 !important;
}

.userinfo-bm-input .el-input__wrapper {
  padding: 0 4px;
}

.userinfo-bm-input .el-input__wrapper:hover,
.userinfo-bm-input .el-input__wrapper,
.userinfo-bm-input .el-select .el-input.is-focus .el-input__wrapper,
.userinfo-bm-input .el-select .el-input__wrapper.is-focus {
  box-shadow: none !important;
}

/*userinfo end*/

/**equity start*/
.equity-header-btn .el-button.is-disabled,
.equity-header-btn .el-button.is-disabled:focus,
.equity-header-btn .el-button.is-disabled:hover {
  color: var(--equity-header-btn-color);
  background-color: var(--equity-header-btn-bgcolor);
  border: transparent;
  border-color: transparent;
}

/**equity end*/

/**zfMsg start*/
.zfMsgForm .el-radio-button__inner {
  padding: 6px 10px;
}

.zfMsgForm .el-radio-button .el-radio-button__inner {
  border: 1px solid #ccc;
  border-radius: 20px;
}

.zfMsg-bm-input .el-input__wrapper:hover,
.zfMsg-bm-input .el-input__wrapper,
.zfMsg-bm-input .el-select .el-input.is-focus .el-input__wrapper,
.zfMsg-bm-input .el-select .el-input__wrapper.is-focus {
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
    inset !important;
  padding: 0 20px;
  border-radius: 20px;
}

.zfMsg-bm-input textarea {
  padding: 15px 20px;
  border-radius: 20px;
}

.zfMsg-bm-input .el-textarea__inner {
  padding-bottom: 36px;
}

.zfMsg-update-item .el-tag {
  font-size: 16px;
  padding: 18px 20px;
}

/**zfMsg end*/

/**Dfm start*/
.content-bm-input.userinfo-bm-input .el-input__wrapper {
  padding: 0;
}

/**Dfm end*/

/***loadind start */
.loading .el-loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading .el-loading-mask {
  background-color: transparent;
}

.loading .circular {
  width: 30px;
  margin-right: 10px;
}

.loading .path {
  stroke: var(--ccc);
}

.loading .el-loading-text {
  color: var(--ccc);
}
/***loading end */

/**app start */
.el-divider__text {
  color: var(--ccc);
}
.active-container .footer-txt p {
  color: #fff;
}
/**app end */

.el-carousel__indicators--horizontal {
  bottom: 8vw;
}

.game-container .el-dialog__body {
  padding: 0 10px 10px 10px;
}

.game-container .el-dialog__header {
  margin-right: 0;
}

.game-container .el-dialog__headerbtn .el-dialog__close {
  font-size: 20px;
}
</style>
